<template>
  <StockBollinger />
</template>

<script>
import StockBollinger from '@/components/indicators/StockBollinger.vue'

export default {
  name: 'StockBollingerView',
  components: {
    StockBollinger
  }
}
</script>

<style scoped>
.stock-bollinger-view {
  flex: 1;
}
</style>
